import { useState, useEffect } from 'react';
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import LandingPageOne from './components/LandingPageOne';
import Layout from './components/Layout';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions'
import CookiePolicy from './components/CookiePolicy'
import { initFacebookPixel } from './facebookPixel';

function App() {

  const [form, setForm] = useState({
    email: "",
    firstName: "",
    lastName: "",
    cellPhone: "",
    totalDebt: "$1 - $4,999"
  })
  const updateFieldValue = (name, value) => {
    let newDataArray = { ...form };
    newDataArray[name] = value
    setForm(newDataArray)
    // console.log(name, value)
  }


  useEffect(() => {
    initFacebookPixel('1414633156380774');
  }, []);



  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path='/' element={<LandingPageOne updateFieldValue={updateFieldValue} form={form} setForm={setForm} did={``} />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/cookie-policy' element={<CookiePolicy />} />
          <Route path='/terms-conditions' element={<TermsConditions />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
export default App;